import React, { useState } from "react";
import "../Styles/CloudProHeader.css";
import logo from "../Assets/icons/newLogo.png";
import { FaUserCircle, FaBars, FaTimes, FaKey, FaFileAlt, FaSignOutAlt, FaCog ,FaInfoCircle,FaPen,FaUserEdit,FaUserCheck ,FaTasks    } from "react-icons/fa";
import { useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
export default function CloudProHeader(isAdmin) {
  const location = useLocation()
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
    const [showAboutModal, setShowAboutModal] = useState(false);
  const dropdownRef = useRef(null);
  const { mdId } = useParams();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const role = localStorage.getItem('role');
  const handleLogout = () => {
    const keys = ['@user', '@customer', 'userEmail', 'siId', 'siId_locked', 'role', 'md_ref', 'selectedProject', 'selectedProjectName', 'displayMode','panelContentId'];
    keys.forEach(key => localStorage.removeItem(key));
    localStorage.removeItem('@user');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('siId');
    localStorage.removeItem('siId_locked');
    localStorage.removeItem('role');
    localStorage.removeItem('selectedProject');
    localStorage.removeItem('selectedProjectName');
    // optional: also clear md_ref if you don't want it kept
    // localStorage.removeItem('md_ref');
    const sessionKeys = [
      'selectedProject',
      'selectedProjectName',
      'panelContentId',
      'selectedPanel',
      'selectedLoop',
      'updatedPanelContentId',
      'panelVersion', "panelVersion1",'displayMode'
    ];
    sessionKeys.forEach(key => sessionStorage.removeItem(key));
    navigate(`/${mdId}/cloudprologin`);
  };
  const handleNavClick = (path) => {

    navigate(path);
  };
   
  const goCreateSI = () => handleNavClick(`/${mdId}/cloudpromdcreatesi`);
  const goCreateUserInCompany = () => handleNavClick(`/${mdId}/cloudpromdcreatet`);
  const goVeloxLogs = () => handleNavClick(`/${mdId}/md_logs`);
  const goRequestCloudKey = () => handleNavClick(`/${mdId}/cloudpromdrequestkey`);
  const goAssignCloudKey = () => handleNavClick(`/${mdId}/cloudpromdassignkey`);
  return (
<>

    <nav className="navbar">

      <div className="nav-left">
        <img src={logo} alt="logo"   style={{   maxWidth: "250px",
  width: "100%",
  height: "auto",
  objectFit: "contain"}}/>
      </div>


      <div className="nav-center">
         {(role == 1) && (<button  className={`nav-btn ${location.pathname.includes('cloudpromdmanagement')
            ? 'active' : '' }`}
            onClick={() => handleNavClick(`/${mdId}/cloudpromdmanagement`)}
          >
            Master Distributor Users Management
          </button>)}
        <button className={`nav-btn ${location.pathname.includes('cloudpromdsimanagement')
            ? 'active' : '' }`} onClick={() => handleNavClick(`/${mdId}/cloudpromdsimanagement`)}>System Integrator Users Management</button>
        <button className={`nav-btn ${location.pathname.includes('cloudpromdyubiKeydashboard')
            ? 'active' : ''}`} onClick={() => handleNavClick(`/${mdId}/cloudpromdyubiKeydashboard`)}>  VELOX Cloud Key Dashboard</button>
        <button
          className={`nav-btn ${location.pathname.includes('cloudproprojectconfig') ||
              location.pathname.includes('cloudpropanelconfig') ||
              location.pathname.includes('cloudprocauseeffect') ||
              location.pathname.includes('cloudpromdlogs') ||
              location.pathname.includes('cloudproconfiguation')
              ? 'active' : ''
            }`}
          onClick={() => handleNavClick(`/${mdId}/layout/cloudproprojectconfig`)}
        > Commissioning Tool</button>
      </div>


      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
      </div>


      {menuOpen && (
        <div className="mobile-menu">
           {(role == 1) && (<button  className={`nav-btn ${location.pathname.includes('cloudpromdmanagement')
            ? 'active' : '' }`}
            onClick={() => handleNavClick(`/${mdId}/cloudpromdmanagement`)}
          >
            Master Distributor Users Management
          </button>)}
          <button className={`nav-btn ${location.pathname.includes('cloudpromdsimanagement') ? 'active' : ''}`} onClick={() => handleNavClick(`/${mdId}/cloudpromdsimanagement`)}>System Integrator Users Management</button>
          <button className={`nav-btn ${location.pathname.includes('cloudpromdyubiKeydashboard') ? 'active' : ''}`} onClick={() => handleNavClick(`/${mdId}/cloudpromdyubiKeydashboard`)}>VELOX Cloud Key Dashboard</button>
          <button
            className={`nav-btn ${location.pathname.includes('cloudproprojectconfig') ||
                location.pathname.includes('cloudpropanelconfig') ||
                location.pathname.includes('cloudprocauseeffect') ||
                location.pathname.includes('cloudpromdlogs') ||
                location.pathname.includes('cloudproconfiguation')
                ? 'active' : ''
              }`}
            onClick={() => handleNavClick(`/${mdId}/layout/cloudproprojectconfig`)}
          >Commissioning Tool</button>
        </div>
      )}


      <div className="nav-right" ref={dropdownRef}>


        <div className="profile" onClick={() => setOpen(!open)}>
          <FaUserCircle size={26} />
        </div>


        {open && (
          <div className="dropdown">
         

            {(role == 1) &&
             (<div className="dropdown-item" onClick={goCreateSI}>
             <FaPen />Create System Integrator Admin
            </div>)}
             {(role == 1 || role == 3) && 
             (<div className="dropdown-item" onClick={goCreateUserInCompany}>
              <FaUserEdit />Create User In Your Company
            </div>)}

            {(role == 1) && 
            (<div  className="dropdown-item" onClick={goRequestCloudKey}>
              <FaCog /> Request VELOX CLOUD Key
            </div>)}

            {(role == 1) && 
            (<div className="dropdown-item" onClick={goAssignCloudKey}>
              <FaUserCheck/> Assign VELOX CLOUD Key to System Integrator
            </div>)}

            <div className="dropdown-item" onClick={() => handleNavClick(`/${mdId}/cloudproupdatepassword`)}><FaKey /> Change Password</div>
            <div className="dropdown-item" onClick={() => handleNavClick(`/${mdId}/cloudpromdlogs`)}><FaFileAlt /> Logs</div>
            <div className="dropdown-item" onClick={() => { setOpen(false); setShowAboutModal(true); }}>
  <FaInfoCircle /> About
</div>
            <div className="dropdown-item logout" onClick={handleLogout} ><FaSignOutAlt /> Logout</div>
          </div>
        )}

      </div>
    </nav>
    {showAboutModal && (
      <div className="popup-overlay">
        <div className="popup-box about-modal">
          <img src={logo} alt="Velox logo" style={{ width: "100%", alignItems:"center",marginBottom: "12px" }} />
         <p>Velox Cloud Pro application manages Panel-to-Matrix and Matrix-to-Panel configurations for fire alarm systems. It helps define event mappings and actions system response.</p>
          {/* <p style={{alignItem:"center"}}>Fire Panel Commissioning & Configuration Tool</p> */}
            <p>Version {sessionStorage.getItem("panelVersion1") || "2.0.F7"}</p>
          <p>© {new Date().getFullYear()} Velox Life Safety Inc.     
            <br/>All rights reserved.</p>
          <p>
            Support:
            <a href="mailto:info@velox.ca" style={{color:"#42a5f5"}}> info@velox.ca</a>
          </p>
          <button className="btn close" onClick={() => setShowAboutModal(false)}>
            Close
          </button>
        </div>
      </div>
    )}
    </>
  );
}